import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../../theme/theme";

export const useGlobalSearchStyles = makeStyles({
  searchContainer: {
    background: customTokens.colorNeutralBackground1,
    paddingBottom: "240px",

    "@media (max-width: 1440px)": {
      paddingBottom: "240px",
    },

    "@media (min-width: 769px) and (max-width: 1024px)": {
      paddingBottom: "240px",
    },

    "@media (max-width: 768px)": {
      paddingBottom: "240px",
      paddingTop: "64px",
    },
  },

  searchResultBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    "@media (max-width: 608px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "16px",
    },
  },

  searchResult: {
    cursor: "pointer",
    textDecoration: "underline",
  },

  sortByDropdownWrapper: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },

  sortByDropdown: {
    minWidth: "150px",
    maxWidth: "150px",
    borderBottomColor: customTokens.colorNeutralStroke1,

    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
  },

  searchResultBoxWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },

  resultPageName: {
    padding: "10px 0",
    width: "100%",
    borderBottom: `1px solid ${customTokens.fontDarkGrayBody}`,
  },

  searchResultBox: {
    borderRadius: "8px",
    background: customTokens.colorNeutralBackground1,
    boxShadow: "0 30px 30px -5px rgba(10, 10, 59, 0.05)",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  breadcrumbs: {
    textDecoration: "underline",
    cursor: "pointer",
  },

  tableFooterRow: {
    display: "flex",
    justifyContent: "flex-end",

    "@media (max-width: 600px)": {
      width: "100%",
      justifyContent: "space-between",
    },
  },

  tablePageControls: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  noResultBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    margin: "auto",
  },

  sorryText: {
    textAlign: "center",
    lineHeight: "32px !important",
  },

  aiButton: {
    background: customTokens.colorBrandBackground2,
    color: customTokens.colorBrandForeground2,
    border: `1px solid ${customTokens.colorTransparentStroke}`,
  },
});
